// Generated from SVG to Code Figma Plugin

export const ChannelDiscord3 = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.083 17.5716C14.8161 17.6381 14.5474 17.6988 14.2771 17.75C12.8118 18.0319 11.3058 18.0262 9.84274 17.7331C9.58618 17.6819 9.22306 17.5919 8.75525 17.4644L7.22214 19.5C3.43842 19.3759 2 16.7857 2 16.7857C2 11.0357 4.4656 6.3745 4.4656 6.3745C6.93058 4.44764 9.27618 4.50014 9.27618 4.50014L9.94711 5.39326C10.009 5.38451 10.0712 5.37857 10.1334 5.37638C11.412 5.20316 12.7085 5.20884 13.9855 5.39326L14.7218 4.50014C14.7218 4.50014 17.0689 4.44764 19.5326 6.37637C19.5326 6.37637 21.9998 11.0357 21.9998 16.7857C21.9998 16.7857 20.5433 19.3741 16.7592 19.5L15.083 17.5716Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M6.90234 13.1855C6.90234 12.2499 7.69327 11.4849 8.69358 11.4849C9.69419 11.4849 10.4998 12.2499 10.4832 13.1855C10.4832 14.1205 9.69263 14.8861 8.69358 14.8861C7.70984 14.8861 6.90234 14.1208 6.90234 13.1855Z"
      fill="currentColor"
    />
    <path
      d="M13.3098 13.1855C13.3098 12.2499 14.1007 11.4849 15.0998 11.4849C16.1004 11.4849 16.8907 12.2499 16.8907 13.1855C16.8907 14.1205 16.1001 14.8861 15.0995 14.8861C14.1173 14.8861 13.3098 14.1208 13.3098 13.1855Z"
      fill="currentColor"
    />
  </svg>
);
